class CollapsibleAccordion {
  constructor(detailsEl, group) {
    this.el = detailsEl;
    this.group = group;
    this.summary = detailsEl.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    this.summary.addEventListener('click', (event) => this.onClick(event));
  }

  onClick(event) {
    event.preventDefault();
    if (this.isClosing || this.isExpanding) return;

    this.el.style.overflow = 'hidden';

    if (this.el.open) {
      this.shrink();
    } else {
      this.group.forEach((other) => {
        if (other !== this.el && other.open) {
          other._collapsibleAccordion?.shrink();
        }
      });
      this.expandOpen();
    }
  }

  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) this.animation.cancel();

    this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 350, easing: 'ease-out' });
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => {
      this.isClosing = false;
    };
  }

  expandOpen() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) this.animation.cancel();

    this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 350, easing: 'ease-out' });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => {
      this.isExpanding = false;
    };
  }

  onAnimationFinish(open) {
    this.el.open = open;
    if (open) {
      this.el.setAttribute('open', '');
    } else {
      this.el.removeAttribute('open');
    }

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = '';
    this.el.style.overflow = '';
    this.summary.setAttribute('aria-expanded', open);
  }
}

function initCollapsibleAccordions(root = document) {
  root.querySelectorAll('.collapsible-content').forEach((section) => {
    const detailsList = Array.from(section.querySelectorAll('details[id^="Details-"]'));

    detailsList.forEach((details) => {
      if (details._collapsibleAccordion) return;
      details._collapsibleAccordion = new CollapsibleAccordion(details, detailsList);
      const summary = details.querySelector('summary');
      summary?.setAttribute('role', 'button');
      summary?.setAttribute('aria-expanded', details.hasAttribute('open'));
      if (summary?.nextElementSibling?.id) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
      }
      details.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() !== 'ESCAPE' || !details.open) return;
        event.preventDefault();
        details._collapsibleAccordion.shrink();
        summary.focus();
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCollapsibleAccordions());
} else {
  initCollapsibleAccordions();
}

document.addEventListener('shopify:section:load', (event) => {
  initCollapsibleAccordions(event.target);
});
